import { motion } from "framer-motion";
import { Flag } from "lucide-react";

export default function ChatBubble({ role, content, testId, onReport }) {
    const isUser = role === "user";
    return (
        <motion.div
            data-testid={testId}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className={`flex ${isUser ? "justify-end" : "justify-start"} mb-3`}
        >
            <div className={`group relative max-w-[85%] ${isUser ? "" : "pb-1"}`}>
                <div
                    className={`px-5 py-3 leading-relaxed font-body text-[15px] ${
                        isUser
                            ? "bg-clay text-ink rounded-2xl rounded-tr-sm"
                            : "bg-white text-ink rounded-2xl rounded-tl-sm border border-clayHover/60 shadow-soft"
                    }`}
                    style={{ whiteSpace: "pre-wrap" }}
                >
                    {content}
                </div>
                {!isUser && onReport && (
                    <button
                        data-testid="report-reply-btn"
                        onClick={onReport}
                        className="absolute -bottom-1.5 right-2 opacity-100 md:opacity-0 md:group-hover:opacity-100 focus:opacity-100 transition-opacity flex items-center gap-1 text-[11px] text-inkSoft/70 hover:text-terracotta bg-bone/90 px-2 py-0.5 rounded-full border border-clayHover/60"
                        aria-label="Report this reply"
                    >
                        <Flag className="w-3 h-3" /> report
                    </button>
                )}
            </div>
        </motion.div>
    );
}
